import React from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import IconComponent from '../Icons';
import menu from '../../../lib/json/menu.json';
import { resolveMenuIcon } from './menuIcon';

const IconBadge = styled.span`
  display: inline-flex; align-items: center; justify-content: center;
  flex: 0 0 38px; width: 38px; height: 38px; border-radius: 10px;
  background: #edf2fc; color: #315cbe;
  svg { width: 22px; height: 22px; }
`;

export default function PageTitleIcon({ title, icon }) {
  const { pathname } = useLocation();
  let visibleMenu = menu;
  try {
    const user = JSON.parse(localStorage.getItem('usuarioLogado'));
    if (user && user.usuario !== 'ADMIN') {
      visibleMenu = typeof user.menu === 'string' ? JSON.parse(user.menu) : user.menu;
    }
  } catch (_) { visibleMenu = []; }
  return (
    <IconBadge aria-hidden="true">
      <IconComponent icon={icon || resolveMenuIcon(visibleMenu, pathname, title)} />
    </IconBadge>
  );
}
